@if (title.length > 0){
<h2
	[ngClass]="class"
	class="text-2xl font-semibold text-surface-900 dark:text-surface-0 md:text-3xl"
	[innerHTML]="title"></h2>
}
